import { useUserStore } from '~/stores/user'
import { useEventsStore } from '~/stores/events'
import { USER_AUTH_COOKIE_KEY } from '~/lib/constants/cookies'

export class UserLogoutService {
  constructor({ clientCookieService }) {
    this.clientCookieService = clientCookieService
  }

  logout() {
    const userStore = useUserStore()
    const eventStore = useEventsStore()

    eventStore.reset()
    userStore.logout()

    this.clientCookieService.delete(USER_AUTH_COOKIE_KEY)
  }
}
